import { createActionsHook } from 'src/lib/sweetState';

import { ToneOfVoiceStore } from './ToneOfVoiceStore';

export const useToneOfVoiceActions = createActionsHook(ToneOfVoiceStore);
